import { Pagination } from '../../../../../models/Pagination';
import { useQuery } from '@tanstack/react-query';
import { fetchReserveListItems } from './apiFetchReserveListItems';
import { GlobalReactQueryOptions } from '../../../../config';
import { ProductFilter } from '../../../../../models/Product';
import { browserClient } from '../../../../react-query';
import { ReserveListProductResponseOut } from '../../../../store/api';

const RESERVE_REPORT_LIST_ITEMS_QUERY = 'reserveReportListItems';

interface PropTypes {
    filterMap: ProductFilter;
    pagination: Pagination;
    reserveListId: string;
}

export const useReserveReportProducts = ({ filterMap, pagination, reserveListId }: PropTypes) => {
    const stringifiedFilterMap = JSON.stringify(filterMap);

    const queryKey = [
        RESERVE_REPORT_LIST_ITEMS_QUERY,
        reserveListId,
        { filterMap: stringifiedFilterMap, ...pagination }
    ];
    return useQuery(
        queryKey,
        () => fetchReserveListItems({ filterMap: stringifiedFilterMap, pagination, reserveListId }),
        {
            ...GlobalReactQueryOptions
        }
    );
};

export function updateAcceptedStateOfProducts(reserveReportId: string, accepted: boolean, productId?: string) {
    browserClient.setQueriesData<ReserveListProductResponseOut>(
        [RESERVE_REPORT_LIST_ITEMS_QUERY, reserveReportId],
        oldData => {
            if (!oldData) {
                return oldData;
            }

            return {
                ...oldData,
                hits: oldData?.hits?.map(product => ({
                    ...product,
                    accepted: !productId || product.id === productId ? accepted : product.accepted
                }))
            };
        }
    );
}

export function invalidateReserveReportProducts(reserveReportId: string) {
    return browserClient.invalidateQueries([RESERVE_REPORT_LIST_ITEMS_QUERY, reserveReportId]);
}
